import Input from "../../../components/FormComponents/Input";
import Textarea from "../../../components/FormComponents/Textarea";
import React, { useState } from "react";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";

const CronEditor = ({ file, cronData, setCronData }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { isDirty, markClean } = useDirtyChecker(cronData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const parsedValue = name === "function" ? value : value;

    setCronData((prevData) => ({
      ...prevData,
      [name]: parsedValue
    }));
  };

  const handleSaveCron = async () => {
    try {
      setIsSaving(true);
      const payload = {
        ...cronData,
        name: file.name
      };
      const response = await axiosInstance.put(`/cronconfig/${file.id}`, payload);
      toastSuccess(response?.message || "Cron Saved Successfully");
      markClean();
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <GenericActionBar
        path={
          <div>
            <em>Cron</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSaveCron
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />
      <div className="content_main_section">
        <div className="page_main_section">
          <div style={{ maxWidth: "1000px", margin: "0 auto", width: "100%" }}>
            <div className="builder_form my_3 ">
              <Input label="Expression" value={cronData.expression} onChange={handleInputChange} name="expression" />
            </div>
            <div className="builder_form">
              <Textarea
                label="Function"
                value={JSON.parse(JSON.stringify(cronData.function, null, 2))}
                onChange={handleInputChange}
                name="function"
                textareaClassName="builder_textarea_cron"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CronEditor;
